export function bnrFixClose() {
  if (document.querySelector('.js-bnrFixClose')) {
    const closeBtnEle = document.querySelector('.js-bnrFixClose');

    closeBtnEle.addEventListener('click', function () {
      closeBtnEle.closest('.js-bnrFix').remove();
    });
  }
}
